import geneesmiddelApi from "../../api/geneesmiddelApi";

export default class GeneesmiddelDetailPageHelper {
    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const context = this.context;
        const props = context.props;
        const ajaxActions = props.ajaxActions;
        const params = props.match.params;
        const id = params.geneesmiddelId;

        ajaxActions.started();
        geneesmiddelApi.get(id)
            .then((response) => {
                ajaxActions.ended();
                this._processModel(response);
            })
            .catch((ex) => {
                ajaxActions.failed();
                props.throwException(ex);
            });
    }

    _processModel(response) {
        this.context.setState({
            model: response.data
        });
    }
}